import { propEq } from 'ramda'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { hasValue } from '../../../../utils/helpers/value'
import { useFormState } from '../../../../packages/kiti/components/form/form/FormHandler'
import { usePlaceTypes } from '../../../../utils/helpers/placeTypes'
import FieldsLoader, { useFields } from '../_load/FieldsLoader'
import Picker from '../../../../packages/kiti/components/form/picker/Picker'
import Scroll from '../../../../packages/kiti/components/helpers/Scroll'

const getMapOptions = t => ({
  user: [
    { name: 'ID', id: 'id' },
    { name: t('name'), id: 'name' },
    { name: t('email'), id: 'email' }
  ],
  place: [
    { name: 'ID', id: 'id' },
    { name: t('name'), id: 'name' },
    { name: t('levels'), id: 'levels' }
  ],
  asset: [
    { name: 'ID', id: 'id' },
    { name: t('name'), id: 'name' },
    { name: t('type'), id: 'type' },
    { name: t('place'), id: 'place' }
  ],
  serviceOrder: [
    { name: 'ID', id: 'id' },
    { name: t('number'), id: 'yearly_id' },
    { name: t('placeOrPerson'), id: 'place' },
    { name: t('userField'), id: 'user' },
    { name: t('checklist'), id: 'checklist' },
    { name: t('startDate'), id: 'start_date' },
    { name: t('endDate'), id: 'end_date' }
  ],
  formReply: [
    { name: 'ID', id: 'id' },
    { name: t('number'), id: 'number' },
    { name: t('placeOrPerson'), id: 'place' },
    { name: t('replies'), id: 'replies' }
  ]
})

const FieldsPicker = () => {
  const { t } = useTranslation('export')
  const { handleChangeIn, form } = useFormState()
  const customFields = useFields()
  const [placeTypes] = usePlaceTypes()

  const entity = placeTypes.some(propEq('key', form.entity)) ? 'place' : form.entity
  const options = getMapOptions(t)[entity]

  const allOptions = [...options, ...customFields]

  React.useEffect(() => {
    if (!hasValue(form.fields)) {
      handleChangeIn(['fields'], allOptions)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (form.fieldsConfig?.id === 'all') return false

  return (
    <Scroll height={20}>
      <Picker
        options={allOptions}
        idField="id"
        labelField="name"
        multiple
        value={form.fields || []}
        onChange={handleChangeIn(['fields'])}
      />
    </Scroll>
  )
}

const Wrapper = props => {
  return (
    <FieldsLoader origin={props.origin}>
      <FieldsPicker {...props} />
    </FieldsLoader>
  )
}

export default Wrapper
